import React from "react";

export const CellphoneIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_19549_1857)">
        <path
          d="M4.66665 2.66671V13.3334H11.3333V2.66671H4.66665ZM3.99998 1.33337H12C12.3682 1.33337 12.6666 1.63185 12.6666 2.00004V14C12.6666 14.3682 12.3682 14.6667 12 14.6667H3.99998C3.63179 14.6667 3.33331 14.3682 3.33331 14V2.00004C3.33331 1.63185 3.63179 1.33337 3.99998 1.33337ZM7.99998 11.3334C8.36818 11.3334 8.66665 11.6318 8.66665 12C8.66665 12.3682 8.36818 12.6667 7.99998 12.6667C7.63178 12.6667 7.33331 12.3682 7.33331 12C7.33331 11.6318 7.63178 11.3334 7.99998 11.3334Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_19549_1857">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
